import { render, staticRenderFns } from "./DatepickerFormatted.vue?vue&type=template&id=744085f2"
import script from "./DatepickerFormatted.vue?vue&type=script&lang=ts"
export * from "./DatepickerFormatted.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports